import { render, staticRenderFns } from "./FlowFormQuestion.vue?vue&type=template&id=62346a30&"
import script from "./FlowFormQuestion.vue?vue&type=script&lang=js&"
export * from "./FlowFormQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports